import { render, staticRenderFns } from "./materialApplication.vue?vue&type=template&id=740940ab&"
import script from "./materialApplication.vue?vue&type=script&lang=js&"
export * from "./materialApplication.vue?vue&type=script&lang=js&"
import style0 from "./materialApplication.vue?vue&type=style&index=0&id=740940ab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports